import React, { FC, useCallback, useState } from 'react';
import { NavLink } from 'react-router-dom';
import { connect, useDispatch } from 'react-redux';
import { IRootState } from 'store';
import { logOut } from 'actions/auth';
import { resetUserData } from 'actions/users';
import { resetGlobalState } from 'actions/app-state';
import { resetScholarsData } from 'actions/scholars';
import MobileService from 'services/mobile';
import Logo from 'style/imgs/logo.svg';
import Close from 'style/imgs/icons/parents-close.svg';
import Burger from 'style/imgs/icons/parents-icons/burger.svg';
import Dashboard from 'style/imgs/icons/parents-icons/dashboard.svg';
// import Profile from 'style/imgs/icons/parents-icons/profile-icon.svg';
import Settings from 'style/imgs/icons/parents-icons/setting-icon.svg';
import Information from 'style/imgs/icons/parents-icons/info.svg';
import SignIcon from 'style/imgs/icons/parents-icons/logout-icon.svg';
import Referrals from 'style/imgs/icons/reff.svg';
// import Notifi from 'style/imgs/icons/parents-icons/send-icon.svg';
// import Details from 'style/imgs/icons/parents-icons/work-icon.svg';
import style from './index.module.scss';

const mapStateToProps = (state: IRootState) => ({
  userType: state.users.userData?.type,
});
type SideBarProps = ReturnType<typeof mapStateToProps>;

const ParentsSideBar: FC<SideBarProps> = ({ userType }) => {
  const dispatch = useDispatch();
  const [isExtended, setIsExtended] = useState(true);

  const toggleExtended = () => {
    setIsExtended(!isExtended);
  };

  const onSignOut = useCallback(() => {
    dispatch(resetUserData());
    dispatch(resetScholarsData());
    dispatch(resetGlobalState());
    dispatch(logOut());
  }, [dispatch]);

  return (
    <div
      className={`parentsSidebar ${style.sidebarBody} ${
        !isExtended ? style.sidebarBodyClose : ''
      } ${MobileService.isMobile ? style.tablet : ''}`}
    >
      <div className={style.sidebarBodyInner}>
        <div
          className={
            isExtended
              ? `${style.innerLogo}`
              : `${style.innerLogo} ${style.innerLogoClose}`
          }
        >
          <img src={Logo} alt="" className={style.barLogo} />
          <div
            className={style.collect}
            onClick={toggleExtended}
            role="button"
            tabIndex={0}
            onKeyDown={() => null}
          >
            {isExtended ? (
              <img src={Close} alt="" />
            ) : (
              <img src={Burger} alt="" />
            )}
          </div>
        </div>
        <div className={style.innerNavigation}>
          <div
            className={`${style.navigationPanel} ${
              !isExtended ? style.statusClose : ''
            }`}
          >
            <p className={isExtended ? '' : `${style.navClose}`}>General</p>
            <NavLink
              activeClassName={`${style.activeLink} ${
                MobileService.isMobile ? style.tablet : ''
              }`}
              to="/dashboard/scholars"
            >
              <img src={Dashboard} alt="" />
              <span>
                {userType === 'parent'
                  ? 'Parent’s dashboard'
                  : 'Educators’  dashboard'}
              </span>
            </NavLink>
            {userType === 'parent' && (
              <NavLink
                activeClassName={`${style.activeLink} ${
                  MobileService.isMobile ? style.tablet : ''
                }`}
                to="/dashboard/referrals"
              >
                <img src={Referrals} alt="" />
                <span>Referrals and Rewards</span>
              </NavLink>
            )}
          </div>
          <div
            className={`${style.navigationPanel} ${
              !isExtended ? style.statusClose : ''
            }`}
          >
            <p className={isExtended ? '' : `${style.navClose}`}>
              Manage Profile
            </p>
            <NavLink
              activeClassName={style.activeLink}
              to="/dashboard/account-settings"
            >
              <img src={Settings} alt="" />
              <span>Account settings</span>
            </NavLink>
            {/* {userType === 'parent' && ( */}
            {/*  <> */}
            {/*    <NavLink */}
            {/*      activeClassName={style.activeLink} */}
            {/*      to="/dashboard/billing" */}
            {/*    > */}
            {/*      <img src={Details} alt="" /> */}
            {/*      <span>Plan Details / Billing</span> */}
            {/*    </NavLink> */}
            {/*  </> */}
            {/* )} */}
            <a
              href="https://anetaed.zendesk.com/hc/en-us"
              target="_blank"
              rel="noreferrer"
            >
              <img src={Information} alt="" />
              <span>Help center - FAQ</span>
            </a>
            <a
              href="https://anetaed.com/privacy.html"
              target="_blank"
              rel="noreferrer"
            >
              <img src={Information} alt="" />
              <span>Privacy policy</span>
            </a>
          </div>
          {/* advertising block */}
          {/* <div
            className={
              barStatus
                ? `${style.innerAdvertising}`
                : `${style.innerAdvertising} ${style.innerAdvertisingClose}`
            }
          >
            <img src={Adv} alt="" />
            <p>Set Pro account to explore premium features</p>
            <button type="button">Go Pro</button>
          </div> */}
          <div
            className={
              isExtended
                ? `${style.navigationPanel}`
                : `${style.navigationPanel} ${style.statusClose}`
            }
            style={{
              marginTop: '30px',
              position: 'relative',
              zIndex: 101,
              width: '100%',
            }}
          >
            <div
              role="button"
              onKeyDown={() => null}
              tabIndex={0}
              className={MobileService.isMobile ? style.tabletSignOut : ''}
              onClick={onSignOut}
            >
              <img src={SignIcon} alt="sign Out" />
              <span className={isExtended ? '' : `${style.navClose}`}>
                Sign Out
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default connect(mapStateToProps)(ParentsSideBar);
